import { bindAdsManager, AdType, ErrorCode, loadAndParsePauseVAST, } from '@zattoo/playback-sdk';
import { WebAdsManager } from './web-ads-manager';
import { CustomImaActions } from './actions';
/**
 * Listen to window resize event and resize adsManager
 */
export const WithCustomImaSdk = (Base) => {
    return class AdapterWithImaSdk extends Base {
        actions = CustomImaActions.getInstance();
        adsManager = null;
        get playerName() {
            const baseName = super.playerName;
            return `${baseName}-CustomIma`;
        }
        dispatchContentPauseRequested() {
            this.actions.saveState();
            super.dispatchContentPauseRequested();
        }
        async dispatchContentResumeRequested() {
            await this.actions.restoreState();
            super.dispatchContentResumeRequested();
            return Promise.resolve();
        }
        requestAd(ad) {
            /**
             * When Ad requested while another Ad is playing
             * we must destroy currently playing instance, IMA can't handle it
             */
            this.cleanupAdsManager();
            this.adsManager?.destroy();
            const adsManager = new WebAdsManager(this, ad, this.logger ?? null);
            bindAdsManager(adsManager, this, () => {
                this.cleanupAdsManager();
            }, () => {
                this.pauseRequested(ad);
            }, async () => {
                await this.resumeRequested(ad);
            });
            const vastUrl = ad.vastUrl
                .replace('correlator=[timestamp]', `correlator=${Date.now().toString()}`);
            adsManager.startAdsWith(vastUrl);
            this.adsManager = adsManager;
        }
        // TODO Add loadFastForwardVast
        loadFastForwardVast(ad) {
            this.requestAd(ad);
        }
        loadVast(ad) {
            this.requestAd(ad);
        }
        async loadPauseVast(pauseAdUrl) {
            try {
                const pauseAdData = await loadAndParsePauseVAST(pauseAdUrl);
                this.dispatchPauseAdParsed(pauseAdData);
            }
            catch (error) {
                this.dispatchAdError({
                    adType: AdType.PAUSE,
                    error: {
                        code: ErrorCode.Ad,
                        message: error instanceof Error ? error.message : 'Failed to load pause ad VAST',
                    },
                });
            }
        }
        pauseRequested(ad) {
            this.dispatchContentPauseRequested();
            this.dispatchAdBreakStarted({
                adType: ad.type,
                isChannelAd: ad.isChannelAd,
                maxDuration: ad?.maxDuration,
            });
        }
        async resumeRequested(ad) {
            this.dispatchAdBreakEnded({
                adType: ad.type,
                isChannelAd: ad.isChannelAd,
                maxDuration: ad?.maxDuration,
            });
            await this.dispatchContentResumeRequested();
        }
        imaSetVolume(volume) {
            this.adsManager?.setVolume(volume);
        }
        imaPause() {
            this.adsManager?.pause();
        }
        imaPlay() {
            this.adsManager?.resume();
        }
        imaStop() {
            this.cleanupAdsManager();
        }
        cleanupAdsManager() {
            this.adsManager?.destroy();
            this.adsManager = null;
        }
    };
};
